<template>
  <div>
    <section-header
      id="undertakings"
      :departmentId="departmentId"
      :swiftMove="swiftMove"
      >Undertakings</section-header
    >
    <v-btn v-if="edit == 0" @click="edit = 1" small>
      <v-icon>add</v-icon>Undertaking
    </v-btn>
    <div class="ajaxForm" v-if="edit != 0">
      <template v-if="edit == 2">
        <div style="float: right">
          <a @click="edit = 1">Choose from list of existing undertakings</a>
        </div>
        <h1>Create new undertaking type</h1>
        <p>
          Enter the name of the new undertaking type and click Save. This will
          create the type and add a new undertaking to the file at the same time
        </p>
        <div>
          <v-text-field label="Name" v-model="name" />
          <v-btn @click="createUndertakingType">Save</v-btn>
          <v-btn @click="edit = 0">Cancel</v-btn>
        </div>
      </template>
      <template v-if="edit == 1">
        <div style="float: right">
          <a @click="edit = 2">Create new undertaking type</a>
        </div>
        <h1>Add undertaking</h1>
        <p>Choose the type of undertaking you wish to add</p>
        <ul>
          <li
            v-for="undertakingType in undertakingTypes"
            :key="undertakingType.id"
          >
            <a @click="createUndertaking(undertakingType)">{{
              undertakingType.body
            }}</a>
          </li>
        </ul>
        <hr />
        <v-btn @click="edit = 0">Cancel</v-btn>
      </template>
    </div>
    <v-data-table
      v-if="modifiedUndertakings && modifiedUndertakings.length"
      :headers="headers"
      :items="modifiedUndertakings"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <span v-if="props.item.undertakingType">{{
              props.item.undertakingType.body
            }}</span>
            <span v-if="!props.item.undertakingType">{{
              props.item.typeid
            }}</span>
          </td>
          <td>
            <EntityZ
              :entity="props.item.user"
              format="system"
              v-if="props.item.user"
            />
            <span v-if="!props.item.user">{{ props.item.userid }}</span>
          </td>
          <td>{{ props.item.timestamp | formatDate }}</td>
          <td>
            <v-dialog v-model="props.item.dialogNag" width="500">
              <template v-slot:activator="{ on }">
                <a dark v-on="on">
                  <span v-if="props.item.nagdate">{{
                    props.item.nagdate | formatDate
                  }}</span>
                  <span v-if="!props.item.nagdate">Not set</span>
                </a>
              </template>
              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title
                  >Change nag date</v-card-title
                >
                <v-card-text
                  >Please set the nag date below and click Update</v-card-text
                >
                <v-card-text>
                  <v-date-picker v-model="props.item.nagDate" />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="info" flat @click="updateNag(props.item)"
                    >Update</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
          <td>
            <v-dialog v-model="props.item.dialogComplied" width="500">
              <template v-slot:activator="{ on }">
                <a dark v-on="on">
                  <span v-if="props.item.complieddate">{{
                    props.item.complieddate | formatDate
                  }}</span>
                  <span v-if="!props.item.complieddate">Not set</span>
                </a>
              </template>
              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title
                  >Change complied date</v-card-title
                >
                <v-card-text
                  >Please set the complied date below and click
                  Update</v-card-text
                >
                <v-card-text>
                  <v-date-picker v-model="props.item.compliedDate" />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="info" flat @click="updateComplied(props.item)"
                    >Update</v-btn
                  >
                  <v-btn color="info" flat @click="clearComplied(props.item)"
                    >Clear</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
          <td>
            <v-btn @click="deleteUndertaking(props.item.id)" small>
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div v-if="modifiedUndertakings && modifiedUndertakings.length == 0">
      No undertakings on file
    </div>
    <v-progress-circular
      indeterminate
      color="info"
      v-if="!modifiedUndertakings"
    />
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import EntityZ from "@/components/link/EntityZ";
import SectionHeader from "@/components/file/SectionHeader";
import { convertListOfObjectsToMap } from "@/util/helpers";
export default {
  name: "Undertakings",
  components: {
    EntityZ,
    SectionHeader
  },
  props: ["departmentId", "swiftMove"],
  computed: {
    modifiedUndertakings() {
      if (!this.undertakings) {
        return undefined;
      }
      const undertakingTypeMap = this.undertakingTypes
        ? convertListOfObjectsToMap(this.undertakingTypes, "id")
        : undefined;
      return this.undertakings.map((u) => {
        const undertakingType =
          undertakingTypeMap && undertakingTypeMap[u.typeid]
            ? undertakingTypeMap[u.typeid]
            : undefined;
        const user = this.entities ? this.entities[u.userid] : undefined;
        const nagDate = u.nagdate ? u.nagdate.substr(0, 10) : null;
        const compliedDate = u.complieddate
          ? u.complieddate.substr(0, 10)
          : null;
        return {
          ...u,
          undertakingType,
          user,
          nagDate,
          compliedDate,
          dialogNag: false,
          dialogComplied: false
        };
      });
    }
  },
  data() {
    return {
      edit: 0,
      undertakings: [],
      undertakingTypes: [],
      entities: [],
      name: null,
      headers: [
        {
          text: "Undertaking",
          value: "undertakingType.body"
        },
        {
          text: "User",
          value: "user.nameFormatted"
        },
        {
          text: "Created",
          value: "timestamp"
        },
        {
          text: "Nagdate",
          value: "nagdate"
        },
        {
          text: "Complied",
          value: "complieddate"
        },
        {
          text: " ",
          value: "id"
        }
      ]
    };
  },
  methods: {
    async fetchUndertakings() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/undertakings`
      );
      // console.log(response.data);
      this.undertakings = response.data;
    },
    async fetchEntities() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/undertakings/users`
      );
      // console.log(response.data);
      this.entities = response.data;
    },
    async fetchUndertakingTypes() {
      const response = await nbmlaw.get(`/cors/admin/file/undertakingTypes`);
      // console.log(response.data);
      this.undertakingTypes = response.data;
    },
    async createUndertakingType() {
      await nbmlaw.post(
        `/cors/admin/file/files/${this.$route.params.id}/undertakings`,
        {
          value: this.name
        }
      );
      // console.log(response.data);
      this.fetchUndertakingTypes();
      this.edit = 0;
      this.name = null;
    },
    async createUndertaking(undertakingType) {
      await nbmlaw.post(
        `/cors/admin/file/files/${this.$route.params.id}/undertakings/${undertakingType.id}`,
        null
      );
      // console.log(response.data);
      this.fetchAll();
      this.edit = 0;
    },
    async deleteUndertaking(id) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(
          `/cors/admin/file/files/${this.$route.params.id}/undertakings/${id}`
        );
        // console.log(response.data);
        this.fetchAll();
      }
    },
    async updateNag(item) {
      await nbmlaw.put(
        `/cors/admin/file/files/${this.$route.params.id}/undertakings/${item.id}/nag`,
        {
          name: "date",
          value: item.nagDate
        }
      );
      // console.log(response.data);
      this.fetchAll();
      this.dialogNag = false;
    },
    async updateComplied(item) {
      await nbmlaw.put(
        `/cors/admin/file/files/${this.$route.params.id}/undertakings/${item.id}/complied`,
        {
          name: "date",
          value: item.compliedDate
        }
      );
      // console.log(response.data);
      this.fetchAll();
      this.dialogComplied = false;
    },
    async clearComplied(item) {
      await nbmlaw.put(
        `/cors/admin/file/files/${this.$route.params.id}/undertakings/${item.id}/complied`,
        {
          name: "date",
          value: null
        }
      );
      // console.log(response.data);
      this.fetchAll();
      this.dialogComplied = false;
    },
    fetchAll() {
      this.fetchUndertakings();
      this.fetchEntities();
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchAll();
      }
    }
  },
  created() {
    this.fetchUndertakingTypes();
  }
};
</script>
